/**
 * \file Footer.vue
 * \brief NGWI footer with buttons ...
 *  re-written to accomodate new communcations model between sibling components
    (ie between Footer and other components that need buttons in the Footer)
 *  jip 27.Feb.2018
 */
<template>
  <footer
    class="footer"
    :class="{open: isOpen}"
  >
    <div
      class="footer__toggle"
      @click.stop="isOpen = !isOpen"
    >
      <font-awesome-icon :icon="['fas', 'angle-up']" />
    </div>
    <div class="footer__buttons">
      <div
        class="left"
      >
        <slot v-if="$route.path !== '/'">
          <button
            v-if="LoggedIn"
            class="g-btn g-btn--darker g-btn--rounded buttonLeft"
            @click.stop="footerButtonClick('/')"
          >
            {{ $t("messages.footer.logout") }}
          </button>
          <button
            v-if="$route.path !== '/devicelist' && $route.path !== '/'"
            :title="$t('messages.footer.deviceListHelp')"
            class="g-btn g-btn--darker g-btn--rounded buttonLeft"
            @click.stop="footerButtonClick('/devicelist')"
          >
            {{ $t("messages.footer.devicelist") }}
          </button>
          <button
            v-for="FooterButton in computedButtonsLeft"
            :key="FooterButton.label"
            class="g-btn g-btn--darker g-btn--rounded g-btn--footer"
            :class="FooterButton.className"
            @click.stop="footerButtonClick(FooterButton.route, FooterButton.target)"
          >
            {{ FooterButton.label }}
          </button>
        </slot>
      </div>
      <div class="right">
        <button
          v-for="FooterButton in computedButtonsRight"
          :key="FooterButton.label"
          class="g-btn g-btn--darker g-btn--rounded g-btn--footer"
          :class="FooterButton.className"
          @click.stop="footerButtonClick(FooterButton.route, FooterButton.target)"
        >
          {{ FooterButton.label }}
        </button>
        <button
          :title="$t('messages.footer.aboutHelp')"
          class="g-btn g-btn--darker g-btn--rounded buttonRight"
          @click.stop="aboutButtonClick()"
        >
          {{ $t("messages.footer.about") }}
        </button>
        <button
          :title="$t('messages.footer.settings')"
          class="g-btn g-btn--darker g-btn--rounded buttonRight"
          @click.stop="settingsButtonClick()"
        >
          {{ $t("messages.footer.settings") }}
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
/* ------ */
export default {
  name: 'Footer',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler, LifeCycle],
  props: {
    LoggedIn: {
      type: Boolean,
      default: false
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      FooterButtonArray: [],
      isOpen: false
    }
  },
  computed: {
    computedButtonsLeft() {
      return this.FooterButtonArray.filter(button => button.className === 'ButtonLeft')
    },
    computedButtonsRight() {
      return this.FooterButtonArray.filter(button => button.className === 'ButtonRight')
    }
  },
  watch: {
    '$route'(To, From) {
      this.FooterButtonArray = []
      this.isOpen = false
    },
    PageMessage(Message) {
      if(Message && Message.target === 'FooterButtons') {
        this.FooterButtonArray = Message.data
      }

      // format for IncomingFooterButtonArray
      // var IncomingFooterButtonArray = [
      //   {
      //     label: 'Survey',
      //     route: '/survey',
      //     className: 'buttonLeft'
      //   }
      // ];
    }
  },
  methods: {
    settingsButtonClick() {
      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'Settings'
        }
      })
    },
    footerButtonClick(Route, Target) {
      if(Route) {
        if(Route === '/admin') {
          clearTimeout(this.idleTimeout)
          clearInterval(this.pollTimer)
        }
        this.$router.push(Route)
      } else {
        this.$emit('SetPageMessage', {
          target: Target
        })
      }
    },
    aboutButtonClick() {
      this.$emit('SetPageMessage', {
        target: 'ShowModal',
        modalData: {
          component: 'About'
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .footer {
    @include hardware-accelerate(false);
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    width: 100%;
    color: #999999;
    background-color: $color-footer;
    z-index: $z-ui + 100;
    transform: translateY(100%);
    transition: transform 0.4s;
    padding: 5px;

    &.open {
      transform: translateY(0);
    }

    &__toggle {
      background: $color-footer;
      text-align: center;
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      border-top-right-radius: 50%;
      border-top-left-radius: 50%;
      padding: 2px 20px 0;
      font-size: 25px;
      color: $color-grey;
      cursor: pointer;

      .open & > * {
        transform: rotateZ(180deg);
      }
    }

    &__buttons {
      button {
        font-size: 11px !important; // @TODO no important!
      }
      >* {
        display: grid;
        grid-gap: 5px;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: 40px;
        grid-auto-rows: 40px;

        &:last-child:not(:nth-child(1)) {
          margin-top: 5px;
          padding-top: 5px;
          border-top: 1px solid darken($color-grey-dark, 30);
        }
      }
    }
  }

  @media screen and (min-width: $bp-tablet) {
    .footer {
      @include hardware-accelerate(false);
      position: relative;
      height: 40px;
      transition: all 0s;

      bottom: 40px;
      &.open {
        bottom: 0 !important;
      }

      &__toggle {
        display: none;
      }

      &__buttons {
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >* {
          display: inline-block;

          &:last-child:not(:nth-child(1)) {
            margin-top: 0px;
            padding-top: 0px;
            border-top: 0;
          }
        }
        button {
          font-size: 12px;
        }

        button.buttonLeft {
          float: left;
        }
        button.buttonRight {
          float: right;
        }
      }
    }
  }
</style>
